import React, { useState } from "react";
import { ReadOnlyField, SecondaryButton } from "@ucl/library";
import { faCopy } from "@fortawesome/free-solid-svg-icons";
import "./CopyUrlComponent.scss";

export interface CopyUrlComponentProps {
  url: string;
  label?: string;
  description?: string;
}

export const CopyUrlComponent: React.FC<CopyUrlComponentProps> = ({
  url,
  label = "Share Link",
  description,
}) => {
  const [buttonText, setButtonText] = useState("Copy");
  const [isDisabled, setIsDisabled] = useState(false);

  const handleCopyClick = async () => {
    setIsDisabled(true);

    try {
      await navigator.clipboard.writeText(url);
      setButtonText("Copied!");

      // Reset after 1 second
      setTimeout(() => {
        setButtonText("Copy");
        setIsDisabled(false);
      }, 2000);
    } catch (error) {
      console.error("Failed to copy URL:", error);
      setButtonText("Error");

      // Reset after 1 second
      setTimeout(() => {
        setButtonText("Copy");
        setIsDisabled(false);
      }, 2000);
    }
  };

  return (
    <div className="copy-url-component">
      <div className="copy-url-component__url-field">
        <ReadOnlyField value={url} label={label} description={description} minimal={false} />
      </div>
      <div key={buttonText} className="copy-url-component__copy-button">
        <SecondaryButton
          text={buttonText}
          // color="forest-green"
          iconProps={{
            icon: faCopy,
          }}
          onClick={handleCopyClick}
          disabled={isDisabled}
        />
      </div>
    </div>
  );
};

export default CopyUrlComponent;
